'use client';

import { RotateCw } from 'lucide-react';
import { useEffect } from 'react';

export default function AuthShellError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
       
      console.error('[(auth) error boundary]', error);
    }
  }, [error]);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-50 px-4"
      role="alert"
    >
      <div className="w-full max-w-md space-y-3 rounded-xl border border-slate-200 bg-white p-6 text-center">
        <h1 className="text-lg font-semibold text-slate-900">Something went wrong</h1>
        <p className="text-sm text-slate-600">
          We couldn&apos;t load this page. Try again, or head back to sign in.
        </p>
        {error.digest ? (
          <p className="font-mono text-xs text-slate-400">ref: {error.digest}</p>
        ) : null}
        <div className="flex justify-center gap-2 pt-2">
          <button
            className="duration-DEFAULT inline-flex h-9 items-center gap-2 rounded-lg bg-brand-primary-600 px-4 text-base font-medium text-white transition-colors ease-standard hover:bg-brand-primary-700"
            type="button"
            onClick={() => reset()}
          >
            <RotateCw aria-hidden size={16} />
            Try again
          </button>
          <a
            className="duration-DEFAULT inline-flex h-9 items-center rounded-lg border border-slate-300 bg-transparent px-4 text-base font-medium text-slate-700 transition-colors ease-standard hover:bg-slate-50"
            href="/sign-in"
          >
            Back to sign in
          </a>
        </div>
      </div>
    </div>
  );
}
